module.exports = __webpack_public_path__ + "static/media/E1.fc4aab9f.mp3";


//////////////////
// WEBPACK FOOTER
// ./node_modules/jazzband/demo/samples/piano/E1.mp3
// module id = 120
// module chunks = 0